import shareIcon from "@public/icon/ico-share.svg";
import Image from "next/image";
import ShareModal from "~/components/Article/ShareModal";
import React, { useCallback, useState } from "react";

const Share = (params) => {
  const [openShareModal, setOpenShareModal] = useState(false);
  const share = useCallback(() => {
    if (navigator.share) {
      navigator
        .share({
          title: params.title,
          url: window.location.href,
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    } else {
      setOpenShareModal(true);
    }
  }, [params.title]);

  return (
    <>
      {openShareModal && (
        <ShareModal
          title={params.title}
          onClose={() => setOpenShareModal(false)}
        />
      )}

      <button
        onClick={share}
        className="flex items-center gap-2.5 hover:cursor-pointer hover:underline"
      >
        <Image width={32} height={32} src={shareIcon} alt="Condividi" />
        <span className="hidden text-base sm:block">Condividi</span>
      </button>
    </>
  );
};

export default Share;
